<div class="error-message">
  <h2 mat-dialog-title>{{ title }}</h2>
  <mat-dialog-content class="mat-typography">
    <p>{{ message }}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button class="primary-btn sm-btn" mat-button mat-dialog-close>OK</button>
  </mat-dialog-actions>
</div>